import { useQuery, useMutation } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";

const getCPFPercentageList = async () => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.CPFPercentageAPI}?isAll=true&isTrue=true`
  );
  return data;
};

const getCPFPercentageById = async ({ code }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.CPFPercentageAPI}??isAll=false&code=${code}`
  );
  return data;
};

const insertCPFPercentage = async (input) => {
  const { data } = await http_payroll.post(
    Api_EndPoints.CPFPercentageAPI,
    input
  );
  return data;
};

const insertMultipleCPFPercentage = async (input) => {
  const { data } = await http_payroll.post(
    Api_EndPoints.InsertMultipleCpfpercentage,
    input
  );
  return data;
};

const updateCPFPercentage = async (input) => {
  const { data } = await http_payroll.put(
    Api_EndPoints.CPFPercentageAPI,
    input
  );
  return data;
};

export const useCPFPercentageQuery = () => {
  return useQuery({
    queryKey: [Api_EndPoints.CPFPercentageAPI],
    queryFn: () => getCPFPercentageList(),
  });
};

export const useGetCPFPercentageByIdQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.CPFPercentageAPI],
    queryFn: () => getCPFPercentageById(input),
    refetchOnWindowFocus: false,
  });
};

export const useInsertCPFPercentageMutation = () => {
  return useMutation({
    mutationFn: insertCPFPercentage,
  });
};

export const useInsertMultipleCPFPercentageMutation = () => {
  return useMutation({
    mutationFn: insertMultipleCPFPercentage,
  });
};

export const useUpdateCPFPercentageMutation = () => {
  return useMutation({
    mutationFn: updateCPFPercentage,
  });
};
